<template>
  <section>

    <base-card>
      <h2>找不到該頁面</h2>
      <h3>按此回<router-link to="/coaches">首頁</router-link></h3>
    </base-card>
  </section>
</template>